// extracted by mini-css-extract-plugin
export var errorIcon = "_ln-1";
export var nameLogo = "_ln-0";